var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    id: "Calque_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      "enableBackground": "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.2,56.3V3.8c0-2.1-1.7-3.8-3.8-3.8H14.6c-2.1,0-3.8,1.7-3.8,3.8v52.5c0,1.8,1.3,3.3,3,3.7h32.5 C47.9,59.6,49.2,58.1,49.2,56.3z M44,51.3H15.9V8.8H44V51.3z"
  })));
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNS40LjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FscXVlXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgNjAgNjAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDYwIDYwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojNDI4RUUwO30NCjwvc3R5bGU+DQo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNDkuMiw1Ni4zVjMuOGMwLTIuMS0xLjctMy44LTMuOC0zLjhIMTQuNmMtMi4xLDAtMy44LDEuNy0zLjgsMy44djUyLjVjMCwxLjgsMS4zLDMuMywzLDMuN2gzMi41DQoJQzQ3LjksNTkuNiw0OS4yLDU4LjEsNDkuMiw1Ni4zeiBNNDQsNTEuM0gxNS45VjguOEg0NFY1MS4zeiIvPg0KPC9zdmc+DQo=";
export { SvgComponent as ReactComponent };